import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderFormComponent } from 'src/app/components/routes/order-form/order-form.component';
import { OrderHomeComponent } from './components/order-home/order-home.component';
import { OrderViewComponent } from './components/order-view/order-view.component';

const routes: Routes = [
  { path: '', component: OrderHomeComponent, data: { animation: '' } },
  { path: 'view', component: OrderViewComponent, data: { animation: 'view' } },
  { path: 'edit', component: OrderFormComponent, data: { animation: 'edit', isEdit: true } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderRoutingModule { }
